import {Subscription} from './subscription';
import {Constructor, EventHandler} from './types';

export class SubscriptionsMap {
	private map = new Map<Constructor<any>, EventHandler<any>[]>();

	public add<T>(event: Constructor<T>, handler: EventHandler<T>): void {
		const existEntry = this.map.get(event);
		if (existEntry?.length) {
			existEntry.push(handler);
		} else {
			this.map.set(event, [handler]);
		}
	}

	public remove<T>(event: Constructor<T>, handler: EventHandler<T>): void {
		const existEntry = this.map.get(event);
		if (existEntry) {
			this.map.set(event, existEntry.filter(h => h !== handler));
		}
	}

	public get<T>(event: Constructor<T>): Subscription<T>[] {
		return (this.map.get(event) || []).map(e => new Subscription<T>(e, event));
	}

	public get events(): Constructor<any>[] {
		return [...this.map.keys()];
	}

	public free() {
		this.map.clear();
		this.map = new Map<Constructor<any>, EventHandler<any>[]>();
	}
}
